import React, { useEffect, useRef } from 'react';
import { Icon, Text } from '@fluentui/react';
import { createControlComponent } from "@react-leaflet/core";
import { Marker, Popup, useMap } from 'react-leaflet';
import { LatLng } from 'leaflet';

import ItemRegistroTiempo from '../../models/ItemRegistroTiempo';

import 'leaflet';
import "leaflet-routing-machine";
declare let L : any;

const icon : L.Icon = L.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
});

interface ILeafletMapMarkerComponentProps {
    workPart: ItemRegistroTiempo;
    selectedWorkPart?: ItemRegistroTiempo;
    selectedStart: boolean;
    onSelect: (workPart: ItemRegistroTiempo, start: boolean) => void;
};

const getLatLng = (value: string) : LatLng => {
    const valueArray : string[] = value.split(',');
    return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
};

const LeafletMapMarkerComponent = (props: ILeafletMapMarkerComponentProps) => {
    const map = useMap();

    const markerStartRef = useRef<L.Marker>(null);
    const markerEndRef = useRef<L.Marker>(null);

    useEffect(() => {
        if (props.selectedWorkPart && props.selectedWorkPart.Id === props.workPart.Id) {
            if (props.selectedStart) {
                map.flyTo(getLatLng(props.selectedWorkPart.PosicionGPSInicio), 13);
                markerStartRef.current?.openPopup();
            }
            else {
                map.flyTo(getLatLng(props.selectedWorkPart.PosicionGPSFinal), 13);
                markerEndRef.current?.openPopup();
            }
        }
    }, [props.selectedWorkPart, props.selectedStart, props.workPart.Id, map]);

    const RoutineMachine = createControlComponent(() => {
        const instance = L.Routing.control({
            waypoints: [
                getLatLng(props.workPart.PosicionGPSInicio),
                getLatLng(props.workPart.PosicionGPSFinal),
            ],
            lineOptions: {
                styles: [
                    {
                        color: '#ed6d63', 
                        opacity: 1, 
                        weight: 5,
                    },
                ],
                addWaypoints: false,
            },
            createMarker: function() { 
                return null;
            },
        });
        return instance;
    });
    
    return (
        <>
            {
                props.workPart.PosicionGPSInicio ? (
                    <Marker
                        ref={markerStartRef} 
                        position={getLatLng(props.workPart.PosicionGPSInicio)}
                        icon={icon}
                        eventHandlers={{
                            click: (e: L.LeafletMouseEvent) => {
                                props.onSelect(props.workPart, true);
                            },
                        }}>
                        <Popup>
                            <>
                                <Icon iconName='Play' />
                                <br/>
                                <Text variant="medium">
                                    <strong>
                                        {props.workPart.IdUsuario}
                                    </strong>
                                </Text>
                                <br/>
                                <Text>
                                    {props.workPart.CodigoCliente}
                                </Text>
                                <br/>
                                <Text>
                                    OT: {props.workPart.IdOrden}
                                </Text>
                                <br/>
                                <Text variant="xSmall">
                                    {props.workPart.Inicio}
                                </Text>
                                <br/>
                                <Text>
                                    {props.workPart.Descripcion}
                                </Text>
                            </>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSFinal ? (
                    <Marker
                        ref={markerEndRef}
                        position={getLatLng(props.workPart.PosicionGPSFinal)}
                        icon={icon}
                        eventHandlers={{
                            click: (e: L.LeafletMouseEvent) => {
                                props.onSelect(props.workPart, false);
                            },
                        }}>
                        <Popup>
                            <>
                                <Icon iconName='Pause' />
                                <br/>
                                <Text variant="medium">
                                    <strong>
                                        {props.workPart.IdUsuario}
                                    </strong>
                                </Text>
                                <br/>
                                <Text>
                                    {props.workPart.CodigoCliente}
                                </Text>
                                <br/>
                                <Text>
                                    OT: {props.workPart.IdOrden}
                                </Text>
                                <br/>
                                <Text variant="xSmall">
                                    {props.workPart.Fin}
                                </Text>
                                <br/>
                                <Text>
                                    {props.workPart.Descripcion}
                                </Text>
                            </>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSInicio && props.workPart.PosicionGPSFinal ? (
                    <RoutineMachine />
                ) : (
                    null
                )
            }
        </>
    );
};

export default LeafletMapMarkerComponent;
